<template>
  <v-container fluid>
    <v-form>
      <v-layout row wrap>
        <v-flex xs12 mx-3 pt-2>
          <v-select
            :items="statuses"
            v-model="form.status_id"
            item-value="value"
            item-text="status"
            label="Estado"
            color="grey"
            autocomplete>
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="form.status_id === 8" transition="slide-y-transition">
        <v-flex xs12 mx-3>
          <v-menu
            ref="from"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="form.payment_promise"
            transition="scale-transition"
            min-width="290px"
            lazy
            offset-y
            full-width>
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              class="k-orange-linear-text"
              append-icon="event"
              label="Fecha de compromiso"
              readonly>
            </v-text-field>
            <v-date-picker
              v-model="form.payment_promise"
              @input="$refs.from.save(form.payment_promise)"
              locale="es"
              color="k-orange-linear">
            </v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout row wrap>
      <v-flex xs3 mr-3>
        <v-btn color="black" flat @click="close">CANCELAR</v-btn>
      </v-flex>
      <v-flex xs3 mr-4>
        <v-btn class="k-orange-linear-text" flat @click="save">GUARDAR</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment';
import EventBus from '@/event-bus';
import sidebarFormMixin from '@/mixins/sidebarForm';

export default {
  mixins: [
    sidebarFormMixin,
  ],
  data() {
    return {
      statuses: [],
      from: false,
      channel: 0,
      form: {
        status_id: '',
        payment_promise: '',
      },
      id: 0,
      payment_promise: '',
    };
  },
  created() {
    EventBus.$on('openRightDrawer', () => {
      this.axios.get(`${this.url}?fields=id,status_id,channel_id,payment_promise`).then((response) => {
        this.id = response.data.id;
        this.payment_promise = response.data.payment_promise;
        if (response.data.status_id === 8) {
          this.form = {
            status_id: response.data.status_id,
            payment_promise: response.data.payment_promise,
          };
        } else {
          this.form = {
            status_id: response.data.status_id,
          };
          // eslint-disable-next-line
          this.form.payment_promise ? this.form.payment_promise = null : '';
        }
        this.channel = response.data.channel_id;
        this.axios.get(`notification_schedules/status?channel=${this.channel}&type=1&except=1,2,3,4,14,9,11,12,5,27,29,28`).then((res) => {
          this.statuses = res.data;
        });
      });
    });
  },
  destroyed() {
    EventBus.$off('openRightDrawer');
  },
  computed: {
    dateFormatted() {
      return moment(this.form.payment_promise, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
  },
  watch: {
    'form.status'(val) { // eslint-disable-line
      if (val === 8) {
        if (!this.payment_promise) {
          this.form = {
            status_id: val,
            payment_promise: moment().format('YYYY-MM-DD'),
          };
        } else {
          this.form = {
            status_id: val,
            payment_promise: this.payment_promise,
          };
        }
      } else {
        delete this.form.payment_promise;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/global/sidebar_forms/NotificationScheduleForm.vue